module.exports = __webpack_public_path__ + "static/media/playwright-logo.3a2e616a.svg";